<template>
  <div class="component-body">
    <el-alert
        title="成功提示的文案"
        type="success"
        show-icon>
    </el-alert>
    <el-alert
        class="margin-top-15"
        title="消息提示的文案"
        type="info"
        show-icon>
    </el-alert>
    <el-alert
        class="margin-top-15"
        title="警告提示的文案"
        type="warning"
        show-icon>
    </el-alert>
    <el-alert
        class="margin-top-15"
        title="错误提示的文案"
        type="error"
        show-icon>
    </el-alert>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/21/Alert/index.vue